<template>
  <div 
    class="station-schedule-row schedule-row-container station-batch-draggable"
    @click.prevent="onClick"
    data-type="order"
    :data-orderid="id">
    <div :class="{'schedule-top-area': true, 'schedule-row-hold': onHold || isStoppedRecut || isStoppedCancelled}">
      <div class="schedule-row-highlight-bar" :style="{'background-color': sideBarColour}">
      </div>
      <div class="schedule-row-contents">
        <div class="row no-gutters">
          <div class="col-6 station-row-truncate">
            <h1>Order {{orderSeqNum}}</h1>
          </div>
          <div class="col-2 station-row-truncate">
            
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-6 station-schedule-row-truncate">
            <i class="far fa-user-circle mr-2 fa-fw"></i><span class="station-schedule-row-highlight">{{orderCustomer}}</span>
          </div>
          <div class="col-2 station-schedule-row-truncate">
            <i :class="['fas', 'fa-clock', 'mr-2', 'fa-fw', {'text-danger': isOverdue}]" v-if="dueDate"></i>
            <span class="station-schedule-row-highlight" v-if="!isOverdue && dueDate">{{dueDate | formatTime}}</span>
            <span class="station-schedule-row-highlight station-schedule-row-highlight-overdue text-danger" v-if="isOverdue && dueDate">NOW</span>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-3 station-schedule-row-truncate">
            <i class="far fa-hashtag mr-2 fa-fw"></i><span class="station-schedule-row-highlight">{{stagePanelCount}} / {{orderPanelCount}} Panels</span>
          </div>
          <div class="col-6 station-schedule-row-truncate">
            <i class="far fa-tag mr-2 fa-fw" v-if="orderCustomerRef"></i>{{orderCustomerRef}}
          </div>
          <div :class="['col-3', 'text-right', 'station-schedule-row-label-area', 'station-schedule-row-truncate']">
            <slot name="labels" />
          </div>
        </div>
      </div>
    </div>
    <div class="schedule-progress-area">
    </div>
  </div>
</template>

<style lang="scss" scoped>
.schedule-row-container {
  margin: 5px;
  height: 76px;
  display: flex;
  flex-direction: column;
  color: #A0A0A0;
  cursor: pointer;
  transition: all 0.5s;   /* For transition animations */
}
.schedule-top-area {
  background-color: #333333;
  display: flex;
  flex-direction: row;
  flex: 1.0;
}
.schedule-row-hold {
  background-image: linear-gradient(135deg, #331c1c 33.33%, #4d2121 33.33%, #4d2121 50%, #331c1c 50%, #331c1c 83.33%, #4d2121 83.33%, #4d2121 100%);
  background-size: 42.43px 42.43px;
}
.schedule-row-highlight-bar {
  height: 100%;
  width: 4px;
}
.schedule-row-contents {
  flex: 1.0;
  padding: 4px;
}
.schedule-row-contents > .row {
  margin-bottom: 2px;
}
.schedule-progress-area {
  height: 4px;
}


</style>

<script>
import moment from 'moment'

export default {
  name: 'StationOrderScheduleRow',
  props: {
    id: Number,
    orderSeqNum: String,
    orderCustomer: String,
    orderCustomerRef: String,
    colourHighlight: String,
    isReady: Boolean,
    isCurrentTaskInProduction: Boolean,
    isCurrentTaskAtStation: Boolean,
    stagePanelCount: Number,
    orderPanelCount: Number,
    dueDate: String,
    onHold: Boolean,
    isStoppedRecut: Boolean,
    isStoppedCancelled: Boolean,
  },
  computed: {
    sideBarColour() {
      return this.colourHighlight
    },
    isOverdue() {
      if(!this.dueDate)
        return false
      return moment(this.dueDate).isBefore(moment())
    },
  },
  methods: {
    onClick(evt) {
      this.$emit('click', evt)
    }
  }
}
</script>